<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>
    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item ml-2" aria-current="page">
                            <a routerLink="/purchase-orders">Purchase Orders</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/proof-of-delivery-material"
                                >Proof of Delivery</a
                            >
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div
                                *ngIf="sessionExpired"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                                <span class="relogin" (click)="accountLogout()"
                                    >Click here to LogIn</span
                                >
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <div class="pane-header mb-3">
                                        <h4 class="mt-2">
                                            Select GRN for PO No.
                                            {{ poNumber }}
                                        </h4>
                                    </div>
                                    <div class="search-pane">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label
                                                    class="d-inline-flex align-items-center mb-3"
                                                >
                                                    <select
                                                        id="show-headers"
                                                        class="form-select form-select-sm mx-1"
                                                        (change)="
                                                            onFilter($event)
                                                        "
                                                    >
                                                        <option
                                                            disabled
                                                            selected
                                                            hidden
                                                        >
                                                            Select
                                                        </option>
                                                        <option value="grn_no">
                                                            GRN No
                                                        </option>
                                                        <option
                                                            value="invoice_number"
                                                        >
                                                            GRN Invoice No.
                                                        </option>
                                                        <option
                                                            value="item_code"
                                                        >
                                                            Item Code
                                                        </option>

                                                        <option
                                                            value="po_item_line"
                                                        >
                                                            Line Item
                                                        </option>

                                                        <option value="status">
                                                            Invoicing Status
                                                        </option>
                                                    </select>
                                                </label>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="input-group flex-nowrap"
                                                >
                                                    <ng-container
                                                        *ngIf="selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control highlighted"
                                                            placeholder="Enter search value here"
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                onSearch($event)
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text highlighted"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="!selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Search..."
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                generalSearch(
                                                                    $event
                                                                )
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                    </ng-container>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div
                                                    class="download-pane float-end"
                                                >
                                                    <i
                                                        class="ri-file-download-line"
                                                        (click)="
                                                            exportToExcel()
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <ng-container *ngIf="loading">
                                            <div class="text-center">
                                                <app-loader></app-loader>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!loading">
                                            <div
                                                *ngIf="isEmpty"
                                                class="text-center py-5"
                                            >
                                                <img
                                                    src="assets/images/empty-state.png"
                                                    alt="No-data"
                                                />
                                                <h1 class="card-title my-2">
                                                    No GRNS Available
                                                </h1>
                                                <p class="card-text">
                                                    There is no available data
                                                    to show yet
                                                </p>
                                            </div>
                                            <table
                                                aria-describedby="material-pos"
                                                *ngIf="!isEmpty"
                                                class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint footable-loaded footable purchase-orders text-nowrap"
                                                data-page-size="5"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            *ngIf="
                                                                impersonate ===
                                                                'false'
                                                            "
                                                            data-toggle="true"
                                                        >
                                                            <div
                                                                class="form-check"
                                                            >
                                                                <input
                                                                    *ngIf="
                                                                        !allSubmited
                                                                    "
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    [checked]="
                                                                        isAllCheck()
                                                                    "
                                                                    (change)="
                                                                        checkAll(
                                                                            $event
                                                                        )
                                                                    "
                                                                />
                                                            </div>

                                                            <span></span>
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="grn_no"
                                                        >
                                                            GRN No
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="invoice_number"
                                                        >
                                                            GRN Invoice No.
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="grn_year"
                                                            class="text-center"
                                                        >
                                                            Year
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>

                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="item_code"
                                                            class="text-center"
                                                        >
                                                            Item Code
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>

                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="po_item_line"
                                                            class="text-center"
                                                        >
                                                            Line Item
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>

                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="grn_quantity"
                                                        >
                                                            GRN Quantity
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>

                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="grn_delivery_date"
                                                            class="text-center"
                                                        >
                                                            Delivery Date
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            [appSort]="proof"
                                                            data-order="desc"
                                                            data-name="status"
                                                        >
                                                            Invoicing Status
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="
                                                            let delivery of proof;
                                                            let i = index
                                                        "
                                                    >
                                                        <td
                                                            *ngIf="
                                                                impersonate ===
                                                                'false'
                                                            "
                                                        >
                                                            <div
                                                                class="form-check"
                                                            >
                                                                <input
                                                                    *ngIf="
                                                                        delivery.status ===
                                                                            'Not Invoiced' &&
                                                                        delivery.grn_quality_inspection_status ===
                                                                            'TRUE'
                                                                    "
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    [(ngModel)]="
                                                                        proof[i]
                                                                            .checked
                                                                    "
                                                                    (change)="
                                                                        onCheckboxChange(
                                                                            i
                                                                        )
                                                                    "
                                                                />
                                                                <input
                                                                    *ngIf="
                                                                        delivery.status ===
                                                                            'not invoiced' &&
                                                                        delivery.grn_quality_inspection_status ===
                                                                            'TRUE'
                                                                    "
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    [(ngModel)]="
                                                                        proof[i]
                                                                            .checked
                                                                    "
                                                                    (change)="
                                                                        onCheckboxChange(
                                                                            i
                                                                        )
                                                                    "
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {{
                                                                delivery.grn_no
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                delivery.invoice_number
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                delivery.grn_year
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                delivery.item_code
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                delivery.po_item_line
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                delivery.grn_quantity
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                delivery.grn_delivery_date
                                                            }}
                                                        </td>
                                                        <td>
                                                            <span
                                                                class="badge text-bg-primary"
                                                                [ngClass]="
                                                                    delivery.status ===
                                                                    'Invoiced'
                                                                        ? 'status-green'
                                                                        : 'status-yellow'
                                                                "
                                                            >
                                                                {{
                                                                    delivery.status
                                                                        | titlecase
                                                                }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan="9">
                                                            <button
                                                                *ngIf="
                                                                    impersonate ===
                                                                    'false'
                                                                "
                                                                [disabled]="
                                                                    !isSelected
                                                                "
                                                                class="btn btn-invoice float-end"
                                                                (click)="
                                                                    sendPod()
                                                                "
                                                            >
                                                                Submit Invoice
                                                                for Selected
                                                                Item
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </ng-container>
                                        <!-- <div class="btn-wrapper my-4">
                   
                  </div> -->
                                        <div class="table-footer py-3">
                                            <div class="row">
                                                <div class="col-sm-5">
                                                    <label
                                                        class="d-inline-flex align-items-center mb-3"
                                                    >
                                                        Show
                                                        <select
                                                            id="demo-show-entries"
                                                            class="form-select form-select-sm mx-1"
                                                            [(ngModel)]="
                                                                pageSize
                                                            "
                                                        >
                                                            <option
                                                                [ngValue]="10"
                                                            >
                                                                10
                                                            </option>
                                                            <option
                                                                [ngValue]="25"
                                                            >
                                                                25
                                                            </option>
                                                            <option
                                                                [ngValue]="50"
                                                            >
                                                                50
                                                            </option>
                                                            <option
                                                                [ngValue]="100"
                                                            >
                                                                100
                                                            </option>
                                                        </select>
                                                        entries
                                                    </label>
                                                </div>
                                                <div class="col-sm-7">
                                                    <div class="text-end">
                                                        <!-- Showing 1-5 of 15 entries -->
                                                        <ngb-pagination
                                                            class="justify-content: flex-end !important;"
                                                            [collectionSize]="
                                                                collectionSize
                                                            "
                                                            [(page)]="page"
                                                            [pageSize]="
                                                                pageSize
                                                            "
                                                            [maxSize]="4"
                                                            [rotate]="true"
                                                            [ellipses]="false"
                                                            [boundaryLinks]="
                                                                true
                                                            "
                                                            (pageChange)="
                                                                refreshPo()
                                                            "
                                                        >
                                                        </ngb-pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
